import { advancedFlowSchema_ } from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import {
  AutomationChannel,
  AutomationSortKey,
  AutomationStatus,
} from "@redotech/redo-model/advanced-flow/common";
import { SchemaType } from "@redotech/redo-model/advanced-flow/schemas/schemas";
import { categories } from "@redotech/redo-model/advanced-flow/triggers";
import { SortDirection } from "@redotech/redo-model/tables/table";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const UserInfo = z.object({
  _id: z.string(),
  name: z.string().nullish(),
  email: z.string().nullish(),
});

export type UserInfo = z.infer<typeof UserInfo>;

const getAdvancedFlowsOutput = z.object({
  advancedFlows: z.array(
    advancedFlowSchema_.extend({
      metrics: z.any().optional(),
      isOrigin: z.boolean().optional(),
      canRevert: z.boolean().optional(),
      createdByName: z.string().optional(),
    }),
  ),
  failedToParseFlows: z.array(
    z.object({ _id: z.string(), name: z.string().nullish() }),
  ),
  users: z.map(z.string(), UserInfo).nullish(),
  totalCount: z.number().int(),
});

export const getAdvancedFlows = {
  name: "getAdvancedFlows" as const,
  mock: (generated: z.infer<typeof getAdvancedFlowsOutput>) => ({
    ...generated,
    failedToParseFlows: [],
  }),
  input: z.object({
    getUsers: z.boolean(),
    includeMetrics: z.boolean(),
    includeOriginFlows: z.boolean(),
    searchString: z.string().optional(),
    filters: z
      .object({
        status: z.array(createEnum(AutomationStatus)).optional(),
        channel: z.array(createEnum(AutomationChannel)).optional(),
        category: z.array(createEnum(categories)).optional(),
        schemaType: z.array(createEnum(SchemaType)).optional(),
      })
      .optional(),
    sort: z
      .object({
        key: createEnum(AutomationSortKey),
        direction: createEnum(SortDirection),
      })
      .optional(),
    page: z.optional(z.number().positive().int()),
    pageSize: z.optional(z.number().positive().int()),
    metricsStart: z
      .string()
      .optional()
      .describe("Start date for metrics aggregation (YYYY-MM-DD)"),
    metricsEnd: z
      .string()
      .optional()
      .describe("End date for metrics aggregation (YYYY-MM-DD)"),
  }),
  output: getAdvancedFlowsOutput,
};
